<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center">
      <b-col cols="12" md="4" >
        <font-awesome-icon :icon="['fas', 'check-circle']" class="text-success my-auto success-icon"></font-awesome-icon>
        <h3 class="font-weight-bolder mt-3">{{msgTitle}}</h3>
        <p class="" style="margin-bottom: 55px" v-if="isSuccess">{{`New amount wil be charged on: ${moment(getUser.data.subscription.schedule_start_date)}`}}</p>
        <a class="btn btn-primary btn-block" :href="getFromApps?'musicverse://transaction_done?price=' + this.netPrice:'/#/home'" >Continue</a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'ChangeSubscriptionSuccessPage',
  data() {
    return {
      msgCredit: '',
      lastCredit: 0,
      netPrice: 0,
      orderId: 0,
      currency: 'USD',
      isSuccess: false,
      msgTitle: 'Amount Changed',
      msgDesc: '',
      paymentPendingStatus: '',
      intervalCheck: null,
    };
  },
  async mounted() {
    if (this.changeSubsTrxData !== '') {
      await this.requestDetailUser();
      this.removePaymentDataChangeSubs();
      this.isSuccess = true;
      this.netPrice = this.getUser.data.subscription.next_amount;
    } else {
      this.$router.push({ name: 'HomePage' });
    }
  },
  computed: {
    ...mapGetters('PaymentModule', ['subscriptionTrxData', 'paymentPending', 'intervalCheckPending','changeSubsTrxData']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser', 'getFromApps']),
  },
  methods: {
    ...mapActions('PaymentModule', ['requestConfirmPaymentSubscription', 'requestConfirmPaymentSubscriptionPayMongo',
      'removePaymentDataSubscription', 'setPaymentError', 'setPaymentPending', 'setIntervalCheckPending', 'removeIntervalCheckPending',
      'removePaymentPending', 'removePaymentError','removePaymentDataChangeSubs']),
    ...mapActions('AuthModule', ['requestDetailUser']),
    ...mapActions('NotificationModule', ['setLoading', 'unsetLoading']),
    moment(date) {
      return moment(date).format('DD MMMM YYYY');
    },
    goToHome() {
      this.$router.push({ name: 'HomePage' });
    },
  },
  components: {
    VueCustomTooltip,
  },
};
</script>

<style scoped>
  .cursor-pointer{
    cursor: pointer;
  }
  .success-icon{
    font-size: 134px
  }
  .credit-text{
    font-size: 100px;
  }
  .copy-icon-link{
    right: -40px;top: 25px;
  }
  .copy-icon{
    width: 40px; height: 50px; margin:auto
  }
  .social-item img{
    width: 45px;
  }
  @media screen and (max-width: 767.98px) {
    .credit-text{
      font-size: 50px;
    }
    .copy-icon-link{
      right: 0;
      top: 12px;
    }
    .copy-icon{
      width: 20px; height: 30px; margin:auto
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ChangeSubscriptionSuccess.vue